import { EPeriodsActionTypes } from '../../actions/options/types';
import { DEFAULT_STATE_FETCH_PERIODS } from '../../constants/filterPeriods';
import { EPeriodsStatus, IOptionsState } from '../../types/options';
import { TReduxActions } from '../../types/redux';

export const defaultState: IOptionsState = {
  options: DEFAULT_STATE_FETCH_PERIODS,
  status: EPeriodsStatus.Initial,
};

export const optionsReducer = (state: IOptionsState = defaultState, action: TReduxActions) => {
  switch (action.type) {
    case EPeriodsActionTypes.Succeed:
      return { ...state, options: action.payload, status: EPeriodsStatus.Succeed };
    case EPeriodsActionTypes.Loading:
      return { ...state, status: EPeriodsStatus.Loading };
    case EPeriodsActionTypes.Failed:
      return { ...state, options: DEFAULT_STATE_FETCH_PERIODS, status: EPeriodsStatus.Failed };
    default:
      return state;
  }
};
